import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";
import kw1 from "../../Images/KaluWaterfall/kw1.jpg";
import kw2 from "../../Images/KaluWaterfall/kw2.JPG";
import kw3 from "../../Images/KaluWaterfall/kw3.JPG";
// import kw4 from "../../Images/KaluWaterfall/kw4.jpg";
import kw5 from "../../Images/KaluWaterfall/k5.JPG";

const data = [
  {
    day: "Day 1",
    subheading: "Kalu Waterfall + Zipline Trek",
    schedule: [
      { time: "05:00 AM", activity: "Pick-up at Hadapsar." },
      { time: "05:15 AM", activity: "Pick-up at Swargate." },
      { time: "05:25 AM", activity: "Pick-up at Chhatrapati Shivaji Nagar." },
      { time: "05:45 AM", activity: "Pick-up at Nashik Phata." },
      { time: "07:30 AM", activity: "En-route breakfast." },
      {
        time: "09:00 AM",
        activity: "Arrive at base village and trek briefing.",
      },
      {
        time: "09:30 AM",
        activity: "Begin the trek towards Kalu Waterfall.",
      },
      {
        time: "12:00 PM",
        activity: "Reach Kalu Waterfall and enjoy surrounding nature.",
      },
      {
        time: "01:30 PM",
        activity: "Begin return trek towards the base village.",
      },
      {
        time: "04:00 PM",
        activity: "Delicious Veg & Non-Veg Lunch.",
      },
      {
        time: "05:30 PM",
        activity: "Start the return journey to Pune.",
      },
      {
        time: "11:00 PM",
        activity: "Approx. arrival back in Pune.",
      },
    ],
    meals: ["Breakfast", "Lunch"],
    notes: [
      "Zipline activity fee included in the package.",
      "In case of heavy rainfall or extreme weather conditions, the zipline activity will be skipped for safety and security reasons.",
    ],
    inclusions: [
      "🚌 Transport Pune to Pune by NON-AC bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Delicious Veg & Non-Veg Lunch",
      "☕ Evening Tea",
      "🩺 Basic First Aid & Hydration Powder",
      "🧭 Experienced Trek Lead & Guide",
      "🌲 Forest Entry Charges",
      "⛺ Zipline Activity (subject to weather conditions)",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Any personal insurance or medical expenses beyond basic first aid.",
      "Items of personal nature or additional equipment not listed.",
      "Zipline activity fee if cancelled due to weather (no refund).",
    ],
    verticalCards: [
      { title: "Kalu Waterfall", image: kw1 },
      { title: "Kalu Waterfall", image: kw2 },
      { title: "Kalu Waterfall", image: kw3 },
      // { title: "Kalu Waterfall", image: kw4 },
      { title: "Kalu Waterfall", image: kw5 },
    ],
    trekData: [
      {
        name: "Kalu Waterfall",
        image: kw5,
        info: "Get ready to experience one of the most spectacular monsoon adventures in Maharashtra at Kalu Waterfall, a hidden gem nestled in the breathtaking landscapes of Malshej Ghat! 🌿 Known as one of the tallest and most stunning waterfalls in the Sahyadri ranges, Kalu Waterfall transforms into a roaring natural wonder during the rainy season. Trek through lush green trails, mist-covered valleys, and scenic mountain paths before witnessing the majestic waterfall cascading from great heights. Adding to the thrill, enjoy an exciting zipline ride with panoramic views of the waterfall and surrounding mountains, making this a truly unforgettable adventure. Perfect for nature lovers, photographers, and thrill-seekers, the Kalu Waterfall Trek offers the ideal blend of trekking, adventure, and monsoon beauty. Join us for an exhilarating escape into the heart of the Sahyadris and create memories that will last a lifetime!",
      },
    ],
    faq: [
      {
        question: "What is Kalu Waterfall known for?",
        answer:
          "Kalu Waterfall at Malshej Ghat is famous for its spectacular cascades, natural pools, and the thrilling zipline activity that crosses over the waterfall, making it a unique trekking experience.",
      },
      {
        question: "Is the zipline activity safe?",
        answer:
          "Yes, the zipline activity is completely safe with proper safety equipment and trained guides. However, it will be skipped if weather conditions are unsafe due to heavy rain or strong winds.",
      },
      {
        question: "Is this trek suitable for beginners?",
        answer:
          "Yes. The trail is simple and scenic, making it ideal for beginners with decent fitness levels. The zipline activity is also beginner-friendly with proper training.",
      },
      {
        question: "What should I carry for the trek?",
        answer:
          "Carry a small backpack, water bottle, rain gear, comfortable trekking shoes, sunscreen, and any personal medicine.",
      },
      {
        question: "Are meals included?",
        answer:
          "Yes. Breakfast, morning tea, lunch, and evening tea are included in the package.",
      },
      {
        question: "Is the zipline included in the package?",
        answer:
          "Yes, the zipline activity is included in the package. No additional charges for the zipline experience.",
      },
      {
        question: "Is transportation included?",
        answer:
          "Yes, Pune to Pune travel by NON-AC bus is included in the package.",
      },
      {
        question: "Will we visit the waterfall?",
        answer:
          "Yes, we will reach Kalu Waterfall and spend time exploring the natural pools and scenic views.",
      },
      {
        question: "What if it rains heavily?",
        answer:
          "In case of heavy rainfall or extreme weather conditions, the zipline activity will be cancelled for safety reasons. The trek and waterfall visit will continue as per conditions.",
      },
      {
        question: "Are there food stalls on the way?",
        answer:
          "Yes, food and beverage stalls are available on the way to Kalu Waterfall. Please carry cash as card payments may not be accepted.",
      },
      {
        question: "Will there be a trek leader and guide?",
        answer:
          "Yes, an experienced trek lead and local guide will accompany the group throughout the trek and zipline activity.",
      },
    ],
  },
];

const KaluWaterfall = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Kalu Waterfall + Zipline"
          location="Malshej Ghat"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default KaluWaterfall;
